import React from 'react';
import PropTypes from 'prop-types';
import styles from './ApplicationCreditsBar.module.scss';

const VARIANT_CLASS = {
  blue: styles.barBlue,
  red: styles.barRed,
  orange: styles.barOrange,
};

const ApplicationCreditsBar = ({
  width,
  variant = 'blue',
  className = '',
  emptyIndicator = false,
}) => {
  const barVariant = VARIANT_CLASS[variant] || VARIANT_CLASS.blue;

  return (
    <div
      className={`${styles.barTrack} ${
        emptyIndicator ? styles.barTrackEmpty : ''
      } ${className}`.trim()}
    >
      {emptyIndicator ? (
        <div
          className={`${styles.bar} ${styles.barRed} ${styles.barEmptyIndicator}`}
        />
      ) : (
        <div
          className={`${styles.bar} ${barVariant}`}
          style={{ width: `${width}%` }}
        />
      )}
    </div>
  );
};

ApplicationCreditsBar.propTypes = {
  width: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(['blue', 'red', 'orange']),
  className: PropTypes.string,
  emptyIndicator: PropTypes.bool,
};

export default ApplicationCreditsBar;
